export default __webpack_public_path__ + "static/drop-a-hint-mobile-605ba4201c81f4fee1117785c7a4fb5e.jpg";